import React from "react";
import { BaseDraggable } from "./BaseDraggable";
import { useStore } from "../../stores/store";
import * as bufferOperator from "@arcgis/core/geometry/operators/bufferOperator";
import * as unionOperator from "@arcgis/core/geometry/operators/unionOperator";
import * as convexHullOperator from "@arcgis/core/geometry/operators/convexHullOperator";
import Graphic from "@arcgis/core/Graphic";
import { DraggableKeys } from "../../interfaces/config";
const key = DraggableKeys.BUFFER_DRAGGABLE;
export default function BufferDraggable() {
  const {
    isActive,
    toggleActiveItem,
    results,
    addResults,
    setResults,
    activeResultsType,
    setActiveResultsType,
    primaryQueryLayer,
    highlightLayer,
    bufferLayer,
    bufferGraphic,
    setBufferGraphic,
    selectedResults,
  } = useStore();
  const [bufferDistance, setBufferDistance] = React.useState(100);
  const [bufferUnits, setBufferUnits] = React.useState("feet");

  const isAnySelected = results.length > 0;

  const onBufferClick = React.useCallback(async () => {
    if (!highlightLayer || !primaryQueryLayer) return;
    console.log(selectedResults);
    const geos = results.map((res) => res.geometry);
    const unionedGeo = unionOperator.executeMany(geos) as __esri.GeometryUnion;
    const convexHullGeo = convexHullOperator.execute(unionedGeo) as __esri.GeometryUnion;

    const bufferGeo = bufferOperator.execute(
      convexHullGeo as __esri.GeometryUnion,
      bufferDistance,
      {
        unit: bufferUnits as __esri.LengthUnit
      }
    );

    const symbol = {
      type: "simple-fill",
      color: [255, 100, 193, 0.7],
      outline: {
        color: [255, 100, 193],
        width: 2,
      },
    } as any;

    const bufferGraphic = new Graphic({
      geometry: bufferGeo as any,
      symbol,
    });
    bufferLayer?.removeAll();
    bufferLayer?.add(bufferGraphic);
    setBufferGraphic(bufferGraphic);
    const res = await primaryQueryLayer.queryFeatures({
      geometry: bufferGeo as any,
      returnGeometry: true,
      outFields: ["*"],
    });
    if (activeResultsType === "parcel") {
      addResults(res.features);
    } else {
      setActiveResultsType("parcel");
      setResults(res.features);
    }
  }, [
    highlightLayer,
    primaryQueryLayer,
    bufferDistance,
    bufferUnits,
    selectedResults,
    results,
  ]);

  const onClearBufferClick = () => {
    bufferLayer?.removeAll();
    setBufferGraphic(null);
  };

  return (
    <BaseDraggable
      id={key}
      onClose={() => toggleActiveItem(key)}
      visible={isActive(key)}
      initialPosition="top-right"
      className=""
      headerText="BUFFER"
      size="sm"
    >
      <p>Buffer Selected Features:</p>
      <div>
        <p className="text-sm mt-2">Distance:</p>
        <div className="flex items-center my-2">
          <input
            disabled={!isAnySelected}
            value={bufferDistance}
            onChange={(e) => setBufferDistance(parseInt(e.target.value))}
            type="number"
            className="border border-gray-300 p-1 rounded-sm"
            min={1}
            max={1000}
          />
          <select
            disabled={!isAnySelected}
            value={bufferUnits}
            className="border border-gray-300 p-0.5 rounded-sm ml-2 select select-sm"
            onChange={(e) => setBufferUnits(e.target.value)}
          >
            <option value="feet">Feet</option>
            <option value="miles">Miles</option>
          </select>
        </div>
        {!isAnySelected && (
          <div className="bg-red-100 text-red-500 border border-red-500 p-1 rounded-sm my-4">
            No feature selected, please select one or more features to buffer.
          </div>
        )}
        <div className="flex items-center">
          <button
            onClick={onBufferClick}
            disabled={!isAnySelected}
            className={`btn-athena btn-xs mr-2 ${isAnySelected ? "" : "btn-disabled opacity-50 cursor-not-allowed"
              }`}
          >
            Buffer
          </button>
          <button
            onClick={onClearBufferClick}
            disabled={!bufferGraphic}
            className={`btn-athena btn-xs ${bufferGraphic ? "" : "btn-disabled opacity-50 cursor-not-allowed"
              }`}
          >
            Clear Buffer
          </button>
        </div>
      </div>
    </BaseDraggable>
  );
}
